// urls that are only used inside iframes in heatmap
export const iframeOnlyUrls = [
	'/heatmap-iframes',
	'/heatmap-ai-insights-iframe',
	'/recording-summary-for-iframe-embedd',
	'/compare-heatmap',
	'/editor-iframe-index.html',
	'/heatmap-switch-to-past',
	'/read-only-config',
	'/wingify-ai-v2-panel'
];

/** App instances embedded in an iframe must not react to shared vwo_ca cookie changes (reload/modal). */
export function isAppEmbeddedInIframeContext(): boolean {
	if (typeof window === 'undefined') {
		return false;
	}
	if (window.self !== window.top) {
		return true;
	}
	const locationRef = window.location.hash || window.location.href;
	return iframeOnlyUrls.some((url) => locationRef.includes(url));
}
